import { DropDownMenu, Select } from "components";
import { DateRangePickerField } from "components/formfields";
import {
  dashboardWidgetsItems,
  dashboardWidgetsItemsWithoutReset,
} from "content/Dropdown";
import { MaintenanceOverdueTasks } from "content/Select";
import { useEffect, useState } from "react";

function ChartLayout({
  title,
  children,
  isDateFilter,
  setDate,
  // setShowDashboardWidgets,
}) {
  const [dateRange, setDateRange] = useState({
    startDate: "",
    endDate: "",
  });

  useEffect(() => {
    if (setDate && dateRange.startDate) {
      setDate({ ...dateRange, category: title });
    }
  }, [dateRange, setDateRange, title, setDate]);

  const handleMenuClick = (key) => {
    if (key === "remove") {
      const field = title
        .replace(/\s+(.)/g, (_, char) => char.toUpperCase())
        .replace(/^./, (char) => char.toLowerCase());
      // setShowDashboardWidgets((prev) => {
      //   return {
      //     ...prev,
      //     [field]: false,
      //   };
      // });
    } else if (key === "reset") {
      setDate({ ...dateRange, startDate: "", endDate: "", category: title });
      setDateRange({ ...dateRange, startDate: "", endDate: "" });
    }
  };

  return (
    <div className="flex flex-col min-h-full rounded-md shadow-md border bg-white dark:bg-bgprimary dark:border-gray-800">
      <div className="flex gap-3 justify-between items-center h-16 rounded-t-md px-5 border-b dark:border-gray-800">
        <div className="flex items-center gap-2">
          <span className="font-semibold text-[1.3em] dark:text-gray-200">
            {title}
          </span>
        </div>

        {/* <div className="w-44">
          <Select options={MaintenanceOverdueTasks} />
        </div> */}
        <div className="flex gap-3 items-center">
          {isDateFilter && (
            <DateRangePickerField
              name="dateRange"
              placeholder={["Start date", "End date"]}
              onChange={setDateRange}
              isReset={!dateRange.startDate && !dateRange.endDate}
            />
          )}
          <DropDownMenu
            menuItems={
              isDateFilter
                ? dashboardWidgetsItems
                : dashboardWidgetsItemsWithoutReset
            }
            onMenuClick={(actionKey) => handleMenuClick(actionKey)}
          />
        </div>
      </div>

      {children}
    </div>
  );
}
export default ChartLayout;
